const APPOINTMENT_ACTION_TYPES = Object.freeze({
  FETCH_DATA_CUSTOMER: 'FETCH_DATA_CUSTOMER',
  FETCH_DATA_CUSTOMER_MOBILE: 'FETCH_DATA_CUSTOMER_MOBILE',
  FETCH_DATA_CUSTOMER_TPP: 'FETCH_DATA_CUSTOMER_TPP',
  FETCH_DATA_CUSTOMER_REGION: 'FETCH_DATA_CUSTOMER_REGION',
  FETCH_AVAILABLE_DATES_MOBILE: 'FETCH_AVAILABLE_DATES_MOBILE',
  SET_SLOTNUMBER: 'SET_SLOTNUMBER',
  CLEAR_SLOTNUMBER: 'CLEAR_SLOTNUMBER',
  SET_APPOINTMENT: 'SET_APPOINTMENT',
  SET_APPOINTMENT_MOBILE_BUS: 'SET_APPOINTMENT_MOBILE_BUS',
  SET_APPOINTMENT_MOBILE_TPP: 'SET_APPOINTMENT_MOBILE_TPP',
  UPDATE_APPOINTMENT: 'UPDATE_APPOINTMENT',
});

export default APPOINTMENT_ACTION_TYPES;
